import { z } from 'zod';

import { BankruptcyAgreedOrderId } from '../../../BrandedIds';
import { zodJSPlainDate } from '../../../dates/BrandedDate';
import { BaseLoanEvent } from '../../BaseLoanEvent';

/**
 * Cancels an agreed order the court vacated. The cancelled order stops contributing its excused
 * months and its supplement, so the plan's installments fall back to the contractual base.
 */
export const CancelBankruptcyCh13AgreedOrderEvent = BaseLoanEvent.extend({
  type: z.literal('cancelBankruptcyCh13AgreedOrder'),
  data: z.object({
    agreedOrderId: BankruptcyAgreedOrderId,
    cancelledDate: zodJSPlainDate,
  }),
});
export type CancelBankruptcyCh13AgreedOrderEvent = z.infer<typeof CancelBankruptcyCh13AgreedOrderEvent>;
